import { useMutation } from 'react-query';
import { setAnalyticsEvent } from 'utils/analytics-events';

export const useSubmitAnalyticsEvent = () =>
  useMutation((payload: any) => setAnalyticsEvent(payload));
